export const productShortName = 'Geologia — Edizione Docenti';
export const productBrand = 'Geologia';
export const productEdition = 'Edizione Docenti';
export const productImage = 'https://cdn.magicpatterns.com/uploads/tDRBZmFasyVmdmvij654mN/MOCKUP_GEOLOGIA_SIN_FONDO.png';
export const productImageAlt =
  'Geologia Edizione Docenti: collezione didattica in 6 volumi con 5 risorse bonus, su laptop, tablet e smartphone, accompagnata da minerali, rocce e martello da geologo';

export const checkoutUrl = 'https://geologia-docenti.impultienda.ar/checkout';

export const price = '€27';
export const priceBefore = '€80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '€17';
export const bonusTotalValue = '€85';

export const assurances = ['Pagamento sicuro', 'Accesso immediato', 'Garanzia di 7 giorni'];

export const closingLines = [
  'Basta preparare ogni lezione da zero',
  'Basta spiegare rocce e placche senza materiali chiari',
  'Basta cercare attività e progetti sparsi su internet',
  "Basta verifiche improvvisate all'ultimo minuto",
  'Basta studenti distratti durante le lezioni di scienze',
];
